// @module C3.ShoppingExtensions.ManufacturerPage
define('C3.ShoppingExtensions.PDP.SetsIncluded.Item.CellView'
,	[
	'c3_shoppingextensions_setsincluded_item_cellview.tpl'
	,   'SCView'
	,	'ProductViews.Price.View'
	,	'GlobalViews.StarRating.View'
	,	'Backbone.CompositeView'
	,    'LiveOrder.Model'

	//,	'Backbone'
	,   'Utils'
	,   'Product.Model'
	,   'AjaxRequestsKiller'
	,    'C3.ShoppingExtensions.GroupAddToCart.View'
	,    'Session'
//	,    'SC.Configuration'
	,    'Profile.Model'
	,    'C3.ShoppingExtensions.LoginRegister.View'
	,    'GoogleTagManager'
	,   'Tracker'
	
    ]
, function (
	c3_shoppingextensions_setsincluded_item_cellview_tpl
	,   SCViewModule
	,	ProductViewsPriceView
	,	GlobalViewsStarRatingView
	,	BackboneCompositeView
	,   LiveOrderModel

	//,	Backbone
	,   Utils
	,   ProductModel
	,   AjaxRequestsKiller
	,   GroupAddToCart
	,   Session
	//,   Configuration
	,   ProfileModel
	,   LoginRegisterView
	,   GoogleTagManager
	,   Tracker
	
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

     function PDPSetsIncludedItemsCellView (options) {
     	SCView.call(this, options);

     	this.template = c3_shoppingextensions_setsincluded_item_cellview_tpl;
      	this.application = options.application;
        this.configuration = options.configuration;
      	this.container = options.container;
      	this.origin = options.origin;
      	this.model = options.model;
      	this.hideArrows = options.hideArrows;
      	BackboneCompositeView.add(this);

      	this.contextDataRequest = ['item'];

      	this.showLoginRegisterPopup = function showLoginRegisterPopup(e){
			e.stopPropagation();
			e.preventDefault();
			
			var Layout = this.container.getComponent('Layout');
			//console.log(Layout)

			var view = new LoginRegisterView({
				application: Layout.application
			});



			if (view)
			Layout.showContent(view, {showInModal: true});
	    }	

		this.groupItemPopup = function groupItemPopup(e)
		{
			//e.preventDefault();
	   		//e.stopPropagation();
	   	  // console.log(NXTurnShoppingExtensionsHomeHeader)
		  // NXTurnShoppingExtensionsHomeHeader.showQuickView(e,this.options.application,this.options.layout);

						
		var self = this;
		var $element = jQuery(e.currentTarget)
		var url = $element.attr('data-url');
		var lightboxURL = $element.attr('data-lightbox-url');
		var product = new ProductModel();
    	var promise = jQuery.Deferred();
    	var item = product.get('item');

    	//console.log($element)
    	//console.log(this.options)

    	//var layout = this.options.layout
    	var   application = this.options.application
        ,     Layout = application.getComponent('Layout');
    	//console.log(application)
    	
		item.fetch({
	        data: {url:url},
	        killerId: AjaxRequestsKiller.getKillerId(),
	        pageGeneratorPreload: true
	    }).then(
	        // Success function
	        function(data, _result, jqXhr) {
	        	//console.log(data)
	           if (!item.isNew()) 
	           	{
	             	if (item.get('urlcomponent') &&
	                    SC.ENVIRONMENT.jsEnvironment === 'server') {
	                 	    nsglobal.statusCode = 301;
	                        nsglobal.location = Utils.addSlashToURL(product.generateUrl());
	                }
	               if (data.corrections && data.corrections.length > 0) 
	               {
		               if ( item.get('urlcomponent') &&
		                   SC.ENVIRONMENT.jsEnvironment === 'server') {
		                    	nsglobal.statusCode = 301;
		                        nsglobal.location =
		                        Utils.addSlashToURL(data.corrections[0].url) +
		                        product.getQuery();
		                }else 
		                {
	                       var view = new GroupAddToCart({
								application: application ,model:product
							});
							if (view)
								Layout.showContent(view, {showInModal: true})
		                
		                    promise.reject();
		                }
	                }
	                	// self.bindModel();
	                	promise.resolve();
                } 
                else if (jqXhr.status >= 500) {
                   	// application.getLayout().internalError();
                   	promise.reject();
                }
                else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') 
                {
                    	// We just show the 404 page
                    	// application.getLayout().notFound();
                   		promise.reject();
                }
            },
	        // Error function
	        function(jqXhr) 
	        {
	            // this will stop the ErrorManagment module to process this error
	            // as we are taking care of it
	            jqXhr.preventDefault = true;
				if (jqXhr.status >= 500) {
	                // application.getLayout().internalError();
	                promise.reject();
	            } else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') {
	                // We just show the 404 page
	                // application.getLayout().notFound();
	                promise.reject();
	            }
	        });
	   		//$('#site-footer').addClass('remove-footer-positioning')
            return promise;	
		}			

		this.addQuantity = function addQuantity(e)
		{
			var self=this;
			var $element = self.$(e.target);
	        var quantity_input = $element.parent().find('.item-quantity-value');
	        var button_minus = $element.parent().find('.minus-button');
	       	var find_title_ele = $element.closest('.e2');
	       	var cart = this.container.getComponent('Cart');
	    	var lines=[];

	    	var itemQtyInCurrentOrder = 0;

	    	var itemOrigin = this.origin;

	    	
			var liveOrder = LiveOrderModel.getInstance();
			var item = this.model.get('item');
			//console.log(quantity_input)
			
			var lineData=liveOrder.get('lines').filter(function(line)
			{	
				return line.get('item').get('internalid') == self.model.get('_id')/*item.get('internalid')*/;
	       	});
	       	
	       	if(lineData.length > 0)
	       	{
	       	var lineQuantity=lineData[0].get('quantity');
	       	itemQtyInCurrentOrder = lineQuantity;
	       	}

		    var elementParent = $element.parent('.'+itemOrigin+'.plus-icon');		
			//console.log(elementParent)

	    	var trashCane = $element.parent().find('.product-trash-tray');
	    	   	
	    	//debugger
	       // console.log(find_title_ele)
	        quantity_input.show();
	       // button_minus.show();

	         var parentEle = $element.parent('.'+itemOrigin+'.plus-icon');
	        if(!(parentEle.hasClass('expand-plus-icon')))
	        parentEle.addClass('expand-plus-icon');

	        find_title_ele.addClass('newly-added-css');
	        
	        var old_value = quantity_input.text();

	        if(elementParent.hasClass('add-to-cart-buttons-opened'))
	        {
			var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
			quantity_input.text(new_val);
			}
			
			//console.log(old_value)


			var quantity = quantity_input.text();
			var internalID=quantity_input.attr("data-id");

			//console.log(quantity)

			if(quantity == 1)
	        {
	        	trashCane.show();
	        	button_minus.hide();
	        	quantity_input.css('text-align','left');
	        	
	        }
	        else	
	        {
	        	 button_minus.show();
	        	trashCane.hide();
	        	quantity_input.css('text-align','center');
	        }

			
			if(quantity>0)
			{
				if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
				{
					$element.text('+');
					$element.removeClass('plus-button-additional');

					elementParent.addClass('add-to-cart-buttons-opened');
					elementParent.removeClass('plus-icon-additional');

				}else
				{
					var lineData={quantity: parseFloat(1),
						  		  item: {internalid: parseFloat(internalID)}
					};
					lines.push(lineData);
					SC.loadingIndicatorShow();
					cart.addLines({lines: lines}).then(function() {
						SC.loadingIndicatorHide();
						if(!Utils.isPhoneDevice())
						jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");


						//Snippet for GTM DataLayer
                        var cartLinesDL = liveOrder.get('lines')
                        ,   cartLinesModelsDL = cartLinesDL.models
                        ,   finalCartArray = []

                        _.each(cartLinesModelsDL, function(line) {
                            var lineItem = line.get('item')
                            ,   lineItemName = lineItem.get('displayname')
                            ,   lineItemSKU = lineItem.get('itemid')
                            ,   lineQty = line.get('quantity')
                            ,   lineRate = line.get('rate')
							,   lineGroup = lineItem.get('custitemproduct_category')
							,   lineCategory =  lineItem.get('custitem168')

							finalCartArray.push({
							    'item': lineItemSKU,
							    'quantity':  lineQty,
							    'price': lineRate,
							    'unique_id': lineItemSKU,
							    'ProductGroup' : lineGroup,
							    'ProductCategory' : lineCategory

							})
                        });

                        const gtm = GoogleTagManager;
                        const eventName = 'cartInfo';
                         const eventData = {
                            event: eventName,
                            cartUpdates: finalCartArray
                         }
                         Tracker.trigger(eventName, eventData);
                         gtm.pushData(eventData);
                         //console.log(gtm.win)

                         //console.log(finalCartArray)
                        /*var _etmc = [];
						_etmc.push(['trackCart', {
						    'cart': finalCartArray
						}]);*/
                         //setTimeout(function() { 
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                         //}, 1000); 
					});
					elementParent.addClass('add-to-cart-buttons-opened');	
				}
			}
		}

		this.setsIncludedClick = function setsIncludedClick(e){
            e.preventDefault();

            var sku = this.model.get('itemid');
            //console.log(sku)
            var carouselItemsAppend = $('.SetsIncluded-Items-Append');
            carouselItemsAppend.html("<script>window.dataLayer = window.dataLayer || [];window.gtag('event', 'setsincluded', {'product': '"+sku+"', 'action': 'productview','page_location': '/' });</script>");
            //console.log(carouselItemsAppend)   
        }

		this.removeQuantity = function removeQuantity(e)
		{
			var self=this;

			var $element = self.$(e.target);
	        var quantity_input = $element.parent().find('.item-quantity-value');
	       	var find_title_ele = $element.closest('.e2');
	        var old_value = quantity_input.text();
	       	var cart = this.container.getComponent('Cart');
	       	$element.attr('disabled','disabled');
	    	var lines=[];

	     //  console.log(old_value)
	    	var itemOrigin = this.origin;
	    	
	        var internalID=quantity_input.attr("data-id");
			var liveOrder = LiveOrderModel.getInstance();
			
			var lineData=liveOrder.get('lines').filter(function(line)
			{	
				return line.get('item').get('internalid') == internalID;
	       	});
	       	var lineQuantity=lineData[0].get('quantity');

	       //	console.log(lineQuantity)
	       	
	       	if(lineQuantity==1){
	       		liveOrder.removeLine(
	       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
	       		$element.removeAttr('disabled');
	       	}
	    	else
	    	{
	    		var add_to_cart_promise = liveOrder.updateLine(
	       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
	       		jQuery.when(add_to_cart_promise).done(function( x ) {
  					$element.removeAttr('disabled');
  				});
	    	}

	    	if(old_value==1 )
	        {
	        	var parentEle = $element.parent('.'+itemOrigin+'.plus-icon');
		        if(parentEle.hasClass('expand-plus-icon'))
		        parentEle.removeClass('expand-plus-icon');

		    	if(parentEle.hasClass('add-to-cart-buttons-opened'))
                parentEle.removeClass('add-to-cart-buttons-opened');

	        	find_title_ele.removeClass('newly-added-css');
	        	var new_val = parseFloat(old_value) - 1;

				if(new_val == 0)
                quantity_input.text(1);
                else
                quantity_input.text(new_val);
				
	        	$element.attr("style","display:none !important;");
	        	quantity_input.hide();
	        }
	        else if(old_value>1 ){
	        	var new_val = parseFloat(old_value) - 1;
	        	quantity_input.text(new_val);

	        	if(old_value == 2)
	        	{
	        		var trashCane = $element.parent().find('.product-trash-tray');
			    	var button_minus = $element.parent().find('.minus-button');
			    	//console.log(button_minus)
			    	button_minus.attr("style","display:none !important;");
			    	trashCane.show();
			    	quantity_input.css('text-align','left');
		        	
	        	}
	        }

            //Snippet for GTM DataLayer
            var cartLinesDL = liveOrder.get('lines')
            ,   cartLinesModelsDL = cartLinesDL.models
            ,   finalCartArray = []

            _.each(cartLinesModelsDL, function(line) {
                var lineItem = line.get('item')
                ,   lineItemName = lineItem.get('displayname')
                ,   lineItemSKU = lineItem.get('itemid')
                ,   lineQty = line.get('quantity')
                ,   lineRate = line.get('rate')
				,   lineGroup = lineItem.get('custitemproduct_category')
				,   lineCategory =  lineItem.get('custitem168')

				finalCartArray.push({
				    'item': lineItemSKU,
				    'quantity':  lineQty,
				    'price': lineRate,
				    'unique_id': lineItemSKU,
				    'ProductGroup' : lineGroup,
				    'ProductCategory' : lineCategory

				})
            });

            const gtm = GoogleTagManager;
            const eventName = 'cartInfo';
             const eventData = {
                event: eventName,
                cartUpdates: finalCartArray
             }
             Tracker.trigger(eventName, eventData);
             gtm.pushData(eventData);
             //console.log(gtm.win)

             //console.log(finalCartArray)
            /*var _etmc = [];
			_etmc.push(['trackCart', {
			    'cart': finalCartArray
			}]);*/

            //setTimeout(function() { 
                var appendParentElement = $('.append-abandoned-cart-items')
                appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
             //}, 1000);  

	        if(liveOrder.getTotalItemCount()>0)
	        {
	        	if(!Utils.isPhoneDevice())
	        	jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
	        }
	    }	

		this.getUrlLogin = function getUrlLogin() {
            var url = Session.get('touchpoints.login') +
                '&origin=' +
                (this.configuration.get('currentTouchpoint') || 'home') +
                '&origin_hash=';
            return (url +
                encodeURIComponent(this.origin === 'PDPQUICK'
                    ? this.model.generateURL().replace('/', '')
                    : Backbone.history.fragment));
        }
		 	
     }

     PDPSetsIncludedItemsCellView.prototype = Object.create(SCView.prototype);
     PDPSetsIncludedItemsCellView.prototype.constructor = PDPSetsIncludedItemsCellView;

     PDPSetsIncludedItemsCellView.prototype.getChildViews = function (){
     	return {
     		'Item.Price': function ()
			{
				return new ProductViewsPriceView({
					model: this.model
				,	origin: 'RELATEDITEM'
				});
			}
     	}
     }

      PDPSetsIncludedItemsCellView.prototype.getEvents = function (){
     	return {
     		'mousedown [data-action="plus"]': 'addQuantity',
	   		'mousedown [data-action="minus"]': 'removeQuantity',
	   		'click [data-action="item-quick-view"]': 'groupItemPopup',
   		    'click [data-action="show-login-register-popup"]': 'showLoginRegisterPopup',
   		    'click [data-action="pdp-setsincluded-click"]': 'setsIncludedClick'
     	}
     }

     PDPSetsIncludedItemsCellView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    PDPSetsIncludedItemsCellView.prototype.getContext = function () {
  		var applyStrikeThroughPrice = false
			,   special_formatted_pricelevel1 = ''
			,   special_formatted_pricelevel5 = ''
			,   qtyAvailableInv = this.model.get('custitem_qty_available_inv')
			,   qtyAvailableKit = this.model.get('custitem_qty_available_kit')
			,   itemType = this.model.get('itemtype')
			,   enableOutOfStock = this.model.get('custitem_celigo_shopify_enable_out_sto')
			,   isWebsiteCategoryProduct = this.model.get('custitem157') 
			,   outOfStockDisplay = this.model.get('custitem_aa_out_of_stock_display')
            ,   showOutOfStockButton = false
            ,   showContactForPricingButton = false
			,   serialLotFunctionality = this.model.get('custitem_pdp_seriallot_number_function')
            ,   serialLotMinPrice = this.model.get('custitem_icm_ain_min_price')
            ,   serialLotMaxPrice = this.model.get('custitem_icm_ain_max_price')
            ,   showOutofStock = false;


			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;
			
			if(itemType == "Kit")
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableKit <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
						showOutOfStockButton = true;
					else if(outOfStockDisplay == "Contact for Pricing")
						showContactForPricingButton = true;	
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableInv <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
						showOutOfStockButton = true;
					else if(outOfStockDisplay == "Contact for Pricing")
						showContactForPricingButton = true;	
				}
			}

			


			var lightboxItem = this.model.get('custitem_lightbox_item_url_component');
			var finalLightboxUrl = ''
			,   isKitItemOnly = this.model.get('custitem_kit_item_only') 


			if(lightboxItem !== '' /*&& kititemonly == true*/)
			{
				finalLightboxUrl = "/"+lightboxItem;
			}

			//console.log(this.model)
			//if(this.options.origin !== "mostpopular")
			//{
			var price_detail = this.model.get('onlinecustomerprice_detail')
			,   ItemPrice = ''
			//console.log(price_detail)
			if(price_detail)
			{
				var price_container_object = this.model.getPrice()
				,   pricelevel1 = this.model.get('pricelevel1')
				,   pricelevel1_formatted = this.model.get('pricelevel1_formatted')
				,   onlinecustomerprice_detail = price_detail
				,   applyStrikeThroughPrice = false
				,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
				,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice
				,   ItemPrice = onlinecustomerprice_detail.onlinecustomerprice_formatted
				,	savePrice = 0
				,	savePercent=0
				,	discountPercentage=0;

				if(pricelevel1 && pricelevel1 > onlineprice)
				{
					//console.log(pricelevel1.toLocaleString('en'));
					applyStrikeThroughPrice = true;
				}

				if(pricelevel1_formatted)
					special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
				
				if(price_container_object)
				{
					onlineprice = price_container_object.price_formatted;
					if(onlineprice)
					special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
				}	

				var currPrice = pricelevel5 || pricelevel1 || 0; 
	            if( currPrice < 5){
	                showOutofStock = true;
	            }
			 }
			//}

			var itemQtyInCurrentOrder = 0;

			//using lightbox field condition instead of relateditems
			//if(subCategoriesList.length  == 0)
			if(lightboxItem == '')
			{
				var self = this;
				var liveOrder = LiveOrderModel.getInstance();
				//console.log(liveOrder.get('lines'))
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == self.model.get('_id');
		       	});
		       	if(lineData.length > 0)
		       	{
		       	var lineQuantity=lineData[0].get('quantity');
		       	itemQtyInCurrentOrder = lineQuantity;
		       	}
			}

			var urlComponentValue = "product/"+this.model.get('internalid')
             if(this.model.get('urlcomponent'))
                urlComponentValue = this.model.get('urlcomponent')

            /*if(isKitItemOnly == true)
                showOutofStock = true;*/

            if(applyStrikeThroughPrice)
            {
            	savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
            	discountPercentage = (savePrice / pricelevel1) * 100;
            	savePercent=Math.trunc(discountPercentage)+ "%";
            }
    	return {
    				//@property {String} itemURL
				itemURL: this.model.getFullLink()
				//@property {String} itemName
			,	itemName: this.model.get('_name') || this.model.Name
				// @property {ImageContainer} thumbnail
			,	thumbnail: this.model.getThumbnail()
				//@property {String} sku
			,	sku: this.model.get('_sku')
				// @property {String} itemId
			,	itemId: this.model.get('_id')
				// @property {Item.Model} model
			,	model: this.model
				//@property {Boolean} showRating
			,	showRating: SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled
				//@property {String} track_productlist_list
			,	track_productlist_list: this.model.get('track_productlist_list')
				//@property {String} track_productlist_position
			,	track_productlist_position: this.model.get('track_productlist_position')
				//@property {String} track_productlist_category
			,	track_productlist_category: this.model.get('track_productlist_category')
			//,   isWebsiteCategoryProduct : this.model.get('custitem_kit_item_only') //Using Kit Item Only field
			,   itemQtyInCurrentOrder : itemQtyInCurrentOrder
	        ,    itemQtyInCurrentOrderCheck : itemQtyInCurrentOrder > 0
	        ,    itemQtyInCurrentOrderCheck2 : itemQtyInCurrentOrder < 1
	        ,    origin : this.origin
	        ,    hideArrows : this.hideArrows
	        ,    applyStrikeThroughPrice : applyStrikeThroughPrice
			,    BasePriceFormatted : special_formatted_pricelevel1
			,    OnlinePriceFormatted : special_formatted_pricelevel5
			,    showOutofStock : showOutofStock
			,    plpPrice : ItemPrice
			,	 isWebsiteCategoryProduct : isWebsiteCategoryProduct
			,	 lightBoxItemURL : finalLightboxUrl
			,    hidePricing: ProfileModel.getInstance().hidePrices()
			,    urlLogin: this.getUrlLogin()
			,    urlComponent : urlComponentValue/*this.model.get('urlcomponent')*/
			,    isPhoneDevice : Utils.isPhoneDevice()
			, 	 savePrice : savePrice
			, 	 savePercent:savePercent
			,    showContactForPricingButton : showContactForPricingButton
            ,    showOutOfStockButton : showOutOfStockButton
            ,    serialLotFunctionality : serialLotFunctionality
            ,     serialLotMinPrice: Utils.formatCurrency(serialLotMinPrice)
            ,     serialLotMaxPrice: Utils.formatCurrency(serialLotMaxPrice)
            ,     hasSerialMinMax: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '')
			
            ,    hasSerialMinOnly: (serialLotMinPrice != null && serialLotMinPrice !== '') && !(serialLotMaxPrice != null && serialLotMaxPrice !== '')
            ,    hasSerialMaxOnly: !(serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '')
            ,    serialMinMaxEqual: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '') && parseFloat(serialLotMinPrice) === parseFloat(serialLotMaxPrice)
			};
    }

     return PDPSetsIncludedItemsCellView;

});
